import { FC, useEffect, useState } from 'react';
import { QualityLevel } from 'videojs-contrib-quality-levels';

import { BaseCustomComponentVideo } from '../add-element';

import * as Styled from './quality-levels.styles';

type Props = BaseCustomComponentVideo & {
  xingPlayer: XingPlayer;
};
export const QualityLevels: FC<Props> = ({ xingPlayer }) => {
  const [qualityLevels, setQualityLevels] = useState<QualityLevel[]>([]);

  useEffect(() => {
    xingPlayer.videojs.qualityLevels().on('addqualitylevel', () => {
      const qualityLevels: QualityLevel[] =
        xingPlayer.videojs.qualityLevels().levels_ ?? [];

      const sortedQualityLevels = qualityLevels.sort(
        (a, b) => (a.height ?? 0) - (b.height ?? 0)
      );

      setQualityLevels(sortedQualityLevels);
    });

    return () => {
      xingPlayer.videojs.qualityLevels().off('addqualitylevel');
    };
  }, []);

  const selectItem = (item: any): void => {
    console.log('item selected', item);

    setQualityLevels((qualityLevels) => {
      return qualityLevels.map((q) => ({
        ...q,
        enabled: item.id === 'auto' || q.id === item.id,
      }));
    });
  };

  const handleOnClick = (): void => {
    console.log('handleOnClick button quality levels');

    const isAuto = qualityLevels.findIndex((item) => !item.enabled) < 0;
    const menuList = [];

    qualityLevels.map((qualityLevel) => {
      menuList.push({
        id: qualityLevel.id,
        label: qualityLevel.height + 'p',
        selected: !isAuto && qualityLevel.enabled,
      });
    });

    menuList.push({ id: 'auto', label: 'auto', selected: isAuto });

    xingPlayer.setMenu?.('quality', menuList, selectItem);
  };

  if (qualityLevels.length === 0) {
    return null;
  }

  return (
    <Styled.QualityButtonContainer>
      <Styled.QualityButton
        className="vjs-quality-control vjs-control vjs-button"
        type="button"
        onClick={() => handleOnClick()}
      >
        <span aria-hidden="true" className="vjs-icon-placeholder" />
      </Styled.QualityButton>
    </Styled.QualityButtonContainer>
  );
};
